import axios from "axios";
import Cookies from "js-cookie";
import { apiRoutesForContext } from "src/routes/apiRoutes/react-api-route-paths";
import { PaginationRequest } from "src/sdk";
import { Organisation, TicketFieldSetting } from "src/sdk/models/Organisation";
import { BaseService } from "../services/BaseService";

const tmp = apiRoutesForContext();

export class OrganisationService extends BaseService {
    public authRoutes: typeof tmp;

    constructor() {
        super();
        this.authRoutes = apiRoutesForContext();
    }

    getOrganisations(data: PaginationRequest): Promise<any> {
        const token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            url: this.routes.organisation().getOrganisation()
                + "?pageSize=" + data.pageSize
                + "&page=" + data.page
                + "&search=" + data.search
                + "&sortBy=" + data.sortBy
                + "&sortOrder=" + data.sortOrder,
        });
    }

    getOrganisationById(id: number): Promise<any> {
        const token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            url: this.routes.organisation().getOrganisation() + "/" + id,
        });
    }

      getOrganisationsByUser(): Promise<any> {
        const token = Cookies.get("JwtToken");
        return axios({
            method: "get",
            baseURL: this.routes.server.root(),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            url: this.routes.organisation().getOrganisationsByUser(),
        });
    }

    createOrganisation(data: Organisation): Promise<any> {
        const token = Cookies.get("JwtToken");
        return axios({
            method: "post",
            baseURL: this.routes.server.root(),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            url: this.routes.organisation().createOrganisation(),
            data: data
        });
    }

    editOrganisation(data: Organisation): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "put",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.organisation().editOrganisation() + "/" + data.id,
            data: data
        })
    }

    deleteOrganisation(id: number): Promise<any> {
        const token = Cookies.get("JwtToken");
        return axios({
            method: "delete",
            baseURL: this.routes.server.root(),
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            url: this.routes.organisation().deleteOrganisation() + "/" + id,
        });
    }

    editFieldSetting(data: TicketFieldSetting): Promise<any> {
        var token = Cookies.get("JwtToken");
        return axios({
            method: "put",
            baseURL: this.routes.server.root(),
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            url: this.routes.organisation().editFieldSetting() + "/" + data.fieldId,
            data: data
        })
    }

}
